module.exports = __webpack_public_path__ + "videos/color_jp.5d2994d.mp4";